import Vue  from 'vue'
import Vuex from 'vuex'

import VuexPersist     from 'vuex-persist'
import sharedMutations from 'vuex-shared-mutations'

const vuexPersist = new VuexPersist({
  key: 'migrosApi',
  storage: localStorage
})

Vue.use(Vuex)

export const centralStore = new Vuex.Store({
  plugins: [vuexPersist.plugin, sharedMutations({predicate: ['setAuth', 'setLocale']})],
  strict: true,
  state: {
    fullName: '',
    locale: 'en',
    notes: [],
    lastRoute: '',
    projectId: null,
    profileImage: '/assets/user.png',
    logoImage: '/assets/logodefault.png',
    auth: {
      loggedIn: false,
      csrfToken: '',
      userType: null,
      userId: null,
      isActive: false,
      passwordChanged: false,
    }
  },
  mutations: {
    setAuth (state, payload) {
      state.auth = payload
    },
    setLocale (state, payload) {
      state.locale = payload
    },
    setFullName (state, payload) {
      state.fullName = payload
    },
    setLastRoute (state, payload) {
      state.lastRoute = payload
    },
    setProjectId (state, payload) {
      state.projectId = payload
    },
    setProfileImage (state, payload) {
      state.profileImage = payload
    },
    setlogoImage (state, payload) {
      state.logoImage = payload
    },
    setNotes (state, payload) {
      state.notes = payload
    },
    setLoggedIn (state, payload) {
      state.auth.loggedIn = payload
    }
  },
  actions: {
    setAuth (context, data) {
      context.commit('setAuth', data)
    },
    setLocale (context, data) {
      context.commit('setLocale', data)
    },
    setFullName (context, data) {
      context.commit('setFullName', data)
    },
    setLastRoute (context, data) {
      context.commit('setLastRoute', data)
    },
    setProjectId (context, data) {
      context.commit('setProjectId', data)
    },
    setProfileImage (context, data) {
      context.commit('setProfileImage', data)
    },
    setlogoImage (context, data) {
      context.commit('setlogoImage', data)
    },
    setNotes (context, data) {
      context.commit('setNotes', data)
    },
    setLoggedIn (context, data) {
      context.commit('setLoggedIn', data)
    }
  },
  getters: {
    getAuth (state) {
      return state.auth
    },
    getLocale (state) {
      return state.locale
    },
    getFullName (state) {
      return state.fullName
    },
    getLastRoute (state) {
      return state.lastRoute
    },
    getProjectId (state) {
      return state.projectId
    },
    getProfileImage (state) {
      return state.profileImage
    },
    getLogoImage (state) {
      return state.logoImage
    },
    getNotes (state) {
      return state.notes
    }
  }
})